import { render, staticRenderFns } from "./GDPROverlay.vue?vue&type=template&id=3fba25ed&scoped=true"
import script from "./GDPROverlay.vue?vue&type=script&lang=js"
export * from "./GDPROverlay.vue?vue&type=script&lang=js"
import style0 from "./GDPROverlay.vue?vue&type=style&index=0&id=3fba25ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba25ed",
  null
  
)

export default component.exports